import { prefixWithSeparator as habitatPrefix } from './habitat';
export const prefix = `schemes/`;
export const IDToName = ({ habitatID, schemeID }) => {
    return habitatPrefix + habitatID + '/' + prefix + schemeID;
};
export const nameToID = (name) => {
    const parts = name.split('/');
    if (parts.length !== 4) {
        throw new Error(`bad scheme name: ${name}`);
    }
    return {
        habitatID: parts[1],
        schemeID: parts[3],
    };
};
